"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const React = __importStar(require("react"));
function UnStyledButton(props) {
    // biome-ignore lint: -
    const { dummy } = props, restProps = __rest(props, ["dummy"]);
    return React.createElement("button", Object.assign({}, restProps), "x");
}
exports.CloseButton = (0, styled_components_1.default)(UnStyledButton) `
  padding: 0;
  padding-bottom: 1.5px;
  margin: 0;
  margin-left: 10px;

  line-height: 0.9;
  width: 15px;

  color: black;

  border: 0;
  border: 1px solid rgb(109, 128, 145);
  border-radius: 4px;

  background: linear-gradient(to top, rgb(208, 214, 219), white 50%);

  font-weight: 100;
  font-size: 14px;

  position: absolute;
  right: 4px;
  top: 3px;

  &:hover {
    background: linear-gradient(to top, rgb(92, 172, 245), white 50%);
  }
`;
//# sourceMappingURL=close-button.js.map